import { BackendApiClient } from "../../clients/backend-client";
import { CreateOrderRequest, CreateOrderResponse, PresentsHistoryResponse } from "./models/payments";

export class PaymentsRepository {
    private _client: BackendApiClient;

    constructor() {
        this._client = new BackendApiClient('/api/v2/payments');
    }

    async createOrder(request: CreateOrderRequest): Promise<ApiDataResponse<CreateOrderResponse>> {
        let type = 1000;

        switch (request.type) {
            case "Default":
                type = 0;
                break;
            case "Coupon":
                type = 1;
                break;
            case "Gift":
                type = 2;
                break;
            default:
                break;
        }

        return await this._client.postOrPut<CreateOrderRequest, CreateOrderResponse>("order", {
            currency: request.currency,
            productId: request.productId,
            giftMessage: request.giftMessage,
            giftPlayerId: request.giftPlayerId,
            turnOnAutoSub: request.turnOnAutoSub,
            type: type
        }, 'POST');
    }

    async getPresentsHistory(): Promise<ApiDataResponse<PresentsHistoryResponse[]>> {
        return await this._client.get<PresentsHistoryResponse[]>("presents/history");
    }

    async unsubscribe(): Promise<ApiResponse> {
        return await this._client.postOrPutEmpty("unsubscribe", 'POST');
    }
}